import { useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { opportunitiesInfiniteQueryOptions, type OpportunitiesListFilters } from "@/lib/queries";
import type { Opportunity } from "../types/opportunities.types";

export interface UseOpportunitiesInfiniteParams {
  setId?: string;
  tab: string;
  filters: OpportunitiesListFilters;
  search: string;
  sort: { id: string; desc: boolean } | null;
  pageSize?: number;
  enabled?: boolean;
}

export function useOpportunitiesInfinite({
  setId,
  tab,
  filters,
  search,
  sort,
  pageSize = 10,
  enabled = true,
}: UseOpportunitiesInfiniteParams) {
  const query = useInfiniteQuery(
    opportunitiesInfiniteQueryOptions({
      setId,
      tab,
      filters,
      search,
      sort,
      pageSize,
      enabled,
    }),
  );

  const data: Opportunity[] = useMemo(
    () => query.data?.pages.flatMap((page) => page.items) ?? [],
    [query.data?.pages],
  );

  const totalCount = query.data?.pages[0]?.totalCount ?? 0;

  return {
    data,
    totalCount,
    fetchNextPage: query.fetchNextPage,
    hasNextPage: query.hasNextPage,
    isFetchingNextPage: query.isFetchingNextPage,
    isPending: query.isPending,
    isPlaceholderData: query.isPlaceholderData,
    isError: query.isError,
    error: query.error,
  };
}
